import { csx } from '@vtex/admin-ui'

export const styles = {
  radioGroup: csx({
    'div[data-wrap="true"]': {
      flexWrap: 'nowrap',
    },
    'input[type="radio"]': {
      minWidth: '1.25rem',
    },
  }),
  filters: csx({ '> * > * > *': { width: '100%' } }), // Fixes spacing issue in CheckboxGroup children to occupy full width
  unit: csx({
    marginTop: '$space-6',
  }),
  flexRow: csx({
    display: 'flex',
    gap: '$space-4',
    '>div': {
      flex: 1,
    },
  }),
  flexColumn: csx({
    display: 'flex',
    flexDirection: 'column',
    gap: '$space-3',
  }),
  viewContent: csx({
    display: 'flex',
    gap: '$space-2',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
}
